import { render, staticRenderFns } from "./monthlyForecast_edit.vue?vue&type=template&id=38beaf8f&scoped=true&"
import script from "./monthlyForecast_edit.vue?vue&type=script&lang=js&"
export * from "./monthlyForecast_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38beaf8f",
  null
  
)

export default component.exports